import { useEffect, useState } from "react";

export const useCheckoutQuote = (items, promo, enabled) => {
  const key = JSON.stringify({ items: items.map((item) => ({ lookup_key: item.lookupKey, quantity: item.qty })), promo_code: promo.trim().toUpperCase() || null });
  const [state, setState] = useState({ key: "", quote: null, error: "" });
  useEffect(() => {
    if (!enabled || !JSON.parse(key).items.length) return;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/quote`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: key, signal: controller.signal,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Unable to calculate your total. Check your cart and code.");
        if (!controller.signal.aborted) setState({ key, quote: data, error: "" });
      } catch (e) {
        if (!controller.signal.aborted) setState({ key, quote: null, error: e.message || "Could not update your total." });
      }
    }, 200);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [key, enabled]);
  return state.key === key ? { ...state, pending: false } : { quote: null, error: "", pending: true };
};